import Banner from "molecules/banner";
import React from "react";
import banner from "../../assets/about/banner.png"


export default function AboutUsBanner() {
  return (
    <>
      <Banner
        bannerImage={banner}
        mainHeading="The Buddha Institute"
        subHeading="A nurturing ecosystem for Development Entrepreneurs where compassion enables empowerment, experience enables progress, and resilience enables transformation."
        customClass=" 2xl:max-w-[52%] lg:max-w-[90%] xl:max-w-[70%]"
      />
    </>
  );
}
